import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  list: null,
  current: null,
}

const participantSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setApplicationsList: (state, action) => ({ ...state, list: action.payload }),
    setCurrentApplication: (state, action) => ({ ...state, current: action.payload }),
  }
})

export const { setApplicationsList, setCurrentApplication } = participantSlice.actions
export default participantSlice.reducer
